// Copyright ©️ 2026 eVolve MEP, LLC

import type { SpoolingSettings } from 'components/Autodesk/extensions/SpoolsExtension/types';
import { IsolateBehaviorPopover, type SpoolingSettingsOption } from 'modules/Shop/Spooling/IsolateBehaviorPopover';

const spoolingSettingsOptions = [
  {
    label: 'Fit to view',
    setting: 'fitToView',
  },
  {
    label: 'Spool color key',
    setting: 'colorKeyEnabled',
  },
  {
    label: 'Ghost hidden objects',
    setting: 'ghosting',
  },
] as const satisfies SpoolingSettingsOption<keyof SpoolingSettings>[];

type Props = { spoolingSettings: SpoolingSettings; toggleSetting: (setting: keyof SpoolingSettings) => void };

export const SpoolIsolationPopover = ({ spoolingSettings, toggleSetting }: Props) => (
  <IsolateBehaviorPopover
    settingsState={spoolingSettings}
    settings={spoolingSettingsOptions}
    toggleSetting={toggleSetting}
  />
);
